const ROUTES = {
    HOME: '/',
    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
    NEWSLETTER_VERIFY: (token: string) => `/newsletter/verify/${token}`,
    PRODUCTS: '/products',
    PRICING: '/pricing',
    BLOGS: '/blog',
    FAQS: '/faqs',
    CONTACT: '/contact',
    TERMS_CONDITIONS: '/terms-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    SITE_MAP: '/site-map',
    PRODUCT: (slug: string) => `/products/${slug}`,
    BLOG: (slug: string) => `/blog/${slug}`,
    PROFILE: (id: string | number) => `/profile/${id}`,
    DASHBOARD: (id: string | number) => `/dashboard/${id}`,
    SIGN_IN_WITH_OAUTH: 'signin-with-oauth',
}

export default ROUTES
